<header class="app-header">
  <div class="left-section">
    <!-- chamba-ai#433: replaces the 20px edge arrow that used to bring the
         sidebar back - toggles the rail on desktop, the drawer on mobile. -->
    <button
      type="button"
      class="hdr-icon-btn nav-toggle-button"
      (click)="menuToggle.emit()"
      [attr.aria-label]="navExpanded ? t.HIDE_NAVIGATION : t.SHOW_NAVIGATION"
      [attr.aria-expanded]="navExpanded"
      aria-controls="app-left-navigation"
      [title]="navExpanded ? t.HIDE_NAVIGATION : t.SHOW_NAVIGATION"
    >
      <i class="bi bi-list" aria-hidden="true"></i>
    </button>
    <div class="brand-block" (click)="goHome()" (keydown.enter)="goHome()" role="button" tabindex="0">
      <img src="assets/logo.svg?v=1" alt="" class="brand-logo" />
      <span class="company-name">hustlen.ai</span>
    </div>
  </div>

  <div class="right-section">
    <!-- chamba-ai#433: one account chip - AI credits left this period
         (ring = share left, text = exact count, so "92%" can't be read as
         "92% used") plus the PRO tag when subscribed. Opens Plans. Users
         without an active plan get a separate "Choose a plan" CTA instead of the tag. -->
    @if (credits || applicationsBalance) {
      <button
        type="button"
        class="hdr-account"
        (click)="goToPlans()"
        [attr.aria-label]="creditsLabel"
        [title]="creditsLabel"
      >
        @if (applicationsBalance) {
          <app-credits-ring [remaining]="applicationsBalance.available" [total]="applicationsTotal" [size]="28"></app-credits-ring>
        } @else if (credits) {
          <app-credits-ring [remaining]="credits.remaining" [total]="credits.total" [size]="28"></app-credits-ring>
        }
        <span class="hdr-credits-text">
          <strong>{{ creditsShortLabel }}</strong>
          <span class="hdr-credits-caption">{{ applicationsBalance ? t.APPLICATIONS : t.AI_CREDITS }}</span>
        </span>
        @if (planTagLabel) {
          <span class="hdr-plan-tag"><i class="bi bi-stars" aria-hidden="true"></i>{{ planTagLabel }}</span>
        }
      </button>
    }

    @if (showPlanCta) {
      <button
        type="button"
        class="plan-cta"
        [class.plan-cta-pending]="isSubscriptionPending"
        (click)="goToPlans()"
        [attr.aria-label]="planCtaLabel"
      >
        <i class="bi" [class.bi-stars]="!isSubscriptionPending" [class.bi-exclamation-circle]="isSubscriptionPending" aria-hidden="true"></i>
        <span class="plan-cta-label">{{ planCtaLabel }}</span>
      </button>
    }

    <span class="hdr-divider" aria-hidden="true"></span>

    <!-- chamba-ai#411: notification bell, immediately to the left of the
         language selector. Off per environment until the backend is deployed. -->
    @if (bellEnabled) {
      <app-notification-bell></app-notification-bell>
    }

    <div class="language-menu">
      <button
        type="button"
        class="hdr-icon-btn language-button"
        (click)="toggleLanguageDropdown()"
        [attr.aria-label]="t.LANGUAGE"
        [title]="t.LANGUAGE"
        [attr.aria-expanded]="languageDropdownOpen"
        aria-haspopup="menu"
      >
        <i class="bi bi-globe2" aria-hidden="true"></i>
        <span class="language-code">{{ currentLanguage }}</span>
      </button>

      @if (languageDropdownOpen) {
        <div class="language-dropdown" role="menu" [@fade]>
          @for (item of languageDropdownItems; track item.action) {
            <button
              type="button"
              class="language-item"
              role="menuitemradio"
              [attr.aria-checked]="item.icon === 'check'"
              (click)="handleDropdownAction(item.action!)"
            >
              <span>{{ item.label }}</span>
              @if (item.icon === 'check') {
                <i class="bi bi-check-lg" aria-hidden="true"></i>
              }
            </button>
          }
        </div>
      }
    </div>

    <app-super-dropdown
      class="hdr-avatar"
      [items]="dropdownItems"
      [userLabel]="user?.name || user?.email || ''"
      [avatarUrl]="user?.picture || null"
      [align]="'right'"
      (menuAction)="handleDropdownAction($event)"
    ></app-super-dropdown>
  </div>
</header>
